import { useState } from 'react';
import { useMarketingData } from '../MarketingContext';

export default function KnowledgebasePage() {
  const { knowledgebase } = useMarketingData();
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState<typeof knowledgebase[0] | null>(null);

  const filtered = knowledgebase.filter(k => {
    if (search && !k.title.toLowerCase().includes(search.toLowerCase()) && !k.industry.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  if (selected) {
    return (
      <div className="space-y-4">
        <button onClick={() => setSelected(null)} className="text-sm text-blue-600 hover:underline">← Back to Knowledgebase</button>
        <div className="bg-white border border-gray-200 rounded-xl p-6">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h2 className="text-xl font-bold text-gray-900">{selected.title}</h2>
              <div className="flex gap-2 mt-2">
                <span className="text-xs px-2 py-0.5 bg-blue-50 text-blue-700 rounded-full">{selected.industry}</span>
                <span className="text-xs px-2 py-0.5 bg-purple-50 text-purple-700">{selected.region}</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              { label: 'Overview', value: selected.overview },
              { label: 'Market Segments', value: selected.segments },
              { label: 'Market Size', value: selected.marketSize },
              { label: 'Market Growth', value: selected.growth },
              { label: 'Key Terminology', value: selected.terminology },
              { label: 'Common Channels', value: selected.channels },
              { label: 'Technology Trends', value: selected.trends },
              { label: 'Regulations', value: selected.regulations },
              { label: 'Risks', value: selected.risks },
              { label: 'Opportunities', value: selected.opportunities },
              { label: 'Benchmarks', value: selected.benchmarks },
              { label: 'Customer Pain Points', value: selected.painPoints },
              { label: 'Recommended Tools', value: selected.recommendedTools },
            ].map(section => (
              <div key={section.label}>
                <h3 className="text-sm font-semibold text-gray-900 mb-1">{section.label}</h3>
                <p className="text-sm text-gray-600">{section.value || 'Not documented'}</p>
              </div>
            ))}
          </div>
          <div className="mt-4 flex flex-wrap gap-1.5">
            {selected.tags.map(t => <span key={t} className="text-xs px-2 py-0.5 bg-gray-100 text-gray-600 rounded-full">{t}</span>)}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-gray-900">Industry Knowledgebase</h1><p className="text-sm text-gray-500">Searchable knowledge articles for all relevant industries</p></div>
      <div className="bg-white p-3 rounded-xl border border-gray-200">
        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Search knowledgebase..." className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filtered.map(k => (
          <button key={k.id} onClick={() => setSelected(k)} className="bg-white border border-gray-200 rounded-xl p-5 text-left hover:shadow-md transition-shadow">
            <div className="flex items-center gap-3 mb-2">
              <div className="h-10 w-10 rounded-lg bg-blue-50 flex items-center justify-center text-lg">📚</div>
              <div>
                <div className="text-sm font-bold text-gray-900">{k.title}</div>
                <div className="text-xs text-gray-500">{k.industry} · {k.region}</div>
              </div>
            </div>
            <p className="text-xs text-gray-600 line-clamp-2">{k.overview}</p>
            <div className="flex flex-wrap gap-1 mt-2">
              {k.tags.slice(0, 4).map(t => <span key={t} className="text-[10px] px-1.5 py-0.5 bg-gray-100 text-gray-500 rounded">{t}</span>)}
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
